import m from "./_baseTimes.js";
import g from "./isArguments.js";
import h from "./isArray.js";
import "./isBuffer.js";
import y from "./_isIndex.js";
import A from "./isTypedArray.js";
import { i as b } from "../../_virtual/isBuffer.js";
var d = m, _ = g, u = h, x = b.exports, T = y, c = A, O = Object.prototype, B = O.hasOwnProperty;
function I(s, n) {
  var t = u(s), i = !t && _(s), e = !t && !i && x(s), f = !t && !i && !e && c(s), p = t || i || e || f, o = p ? d(s.length, String) : [], a = o.length;
  for (var r in s)
    (n || B.call(s, r)) && !(p && (r == "length" || e && (r == "offset" || r == "parent") || f && (r == "buffer" || r == "byteLength" || r == "byteOffset") || T(r, a))) && o.push(r);
  return o;
}
var $ = I;
export {
  $ as default
};
//# sourceMappingURL=_arrayLikeKeys.js.map
